import { Navigate } from "react-router-dom"
import { getCookie } from "../../utils/cookies"

export default function ProtectedRoute({ children }) {
  const token = getCookie("accessToken") || getCookie("refreshToken")
  const user = getCookie("user")

  if (!token || !user || user === "undefined") {
    return <Navigate to="/" replace />
  }

  return children
}
